import { createContext, useContext, useMemo } from 'react'
import { DefaultAdminRolesRequiredPerAction } from '@nv/utils'
import { useTranslation } from 'react-i18next'

export const ConfigurationContext = createContext()

export const getDefaultConfiguration = (t) => ({
  languages: {
    en: 'English',
    fr: 'Francais',
  },
  votingMethodOptions: [
    { label: t('admin.electorsList.votedChannelOptions.online'), value: 'online' },
    { label: t('admin.electorsList.votedChannelOptions.mail'), value: 'mail' },
  ],
  electionDate: new Date(),
  minAge: 18,
  registrationPhoneRequired: false,
  includeSingleNameField: false,
  maxSessionTimeMinsAdmin: 30,
  maxSessionTimeMinsVoter: 30,
  votingDistrictOptions: [],
  knownIdNumberTextFieldConfig: {},
  enableManualEntryAddress: true,
  enableSingleFieldMailingAddress: false,
  enableDifferentMailingAddress: true,
  mailingAddressRequiredVoteByMail: false,
  registrationOpensDate: '2025-01-20T00:00:00',

  adminRolesPerAction: DefaultAdminRolesRequiredPerAction,
  contactInfoHelpSupport: false,
  contactInfoHelpSupportData: {},
  includeLoginButtonRegistrationPage: true,
  includeRegisterButtonRegistrationPage: true,
  includeLookupButtonRegistrationPage: false,
  voteReceiptVisibleAlways: true,
  voteReceiptEnabled: true,
  voteReceiptType: 'in-app', // options in-app, external-link
  adminToggleRegistrations: false,
  displayStrikeOffOnlyVotingChannels: [],
  reverseStrikeOffEnabled: true,
  strikeOff: {
    enabled: true,
    requireEvent: false,
    declineBallot: false,
  },
  modules: {
    nominations: false,
    eventAttachments: false,
  },
  voting: {
    enableVouching: false,
    enableAssisting: false,
  },
  voterAuth: {
    pinLogin: false,
  },
  showCurrentTime: true,
  hideSessionTimers: {
    admin: false,
    voter: false,
  },
  showLogoutModal: false,
  showVoterInactivityModal: false,
  voterInactivityWarningMins: 14,
})

export const ConfigurationContextProvider = ({ children }) => {
  const { t } = useTranslation()
  const defaultConfiguration = getDefaultConfiguration(t)

  const value = useMemo(() => defaultConfiguration, [defaultConfiguration])

  return <ConfigurationContext.Provider value={value}>{children}</ConfigurationContext.Provider>
}

export const useConfigurationContext = () => useContext(ConfigurationContext)
